<template>
  <div :class="`frisbuy-slide-navigation--${navigationType}`">
    <div
      class="frisbuy-slide-navigation"
      :style="{
        'pointer-events': isDisablePointerEvents ? 'none' : 'all',
      }"
      @touchstart.prevent="() => touchHandler()"
      @mousedown.prevent="() => touchHandler()"
      @touchmove="(e) => preventClickOnSwipe(e)"
    >
      <div
        class="frisbuy-slide-navigation__button"
        @touchend="(e) => touchendHandler(() => $emit('clickPrev', e))"
        @mouseup="(e) => touchendHandler(() => $emit('clickPrev', e))"
        :style="{ visibility: isShowPrev ? 'visible' : 'hidden' }"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 32"
          xml:space="preserve"
        >
          <polyline
            stroke="currentColor"
            fill="none"
            points="16,24 8,16 16,8"
          />
        </svg>
      </div>

      <div
        class="frisbuy-slide-navigation__button"
        @touchend="(e) => touchendHandler(() => $emit('clickNext', e))"
        @mouseup="(e) => touchendHandler(() => $emit('clickNext', e))"
        :style="{ visibility: isShowNext ? 'visible' : 'hidden' }"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 32"
          xml:space="preserve"
        >
          <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24" />
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "src/common/style/mixins.scss";

$componentClass: ".frisbuy-slide-navigation";

.frisbuy-slide-navigation--default {
  .frisbuy-slide-navigation {
    position: absolute;
    display: flex;
    justify-content: space-between;

    inset: 0;

    z-index: 1;

    margin: &__button;

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 50%;
      height: 100%;

      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;

      svg {
        display: none;
      }
    }

    @media screen and (orientation: portrait) {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: auto;

      &__button {
        background: transparent;
        box-shadow: none;
        width: 50%;
        height: auto;
        border-radius: 0;
        position: absolute;
        height: 100%;
        left: -10px;

        &:last-child {
          left: auto;
          right: -10px;
        }

        svg {
          display: none;
        }
      }
    }

    @media screen and (max-height: 425px) and (orientation: landscape) {
      width: calc(100% + 70px);
      margin-left: -35px;

      &__button {
        margin: 0 -7px;
      }
    }
  }
}

.frisbuy-slide-navigation--arrows {
  .frisbuy-slide-navigation {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: calc(50% - 15px);

    width: calc(100% + 70px);
    height: 0;

    margin-left: -35px;

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 20px;
      height: 20px;

      background-color: #fff;
      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);
      border-radius: 50%;

      opacity: 0.8;
      cursor: pointer;
      margin: 0 5px;

      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      -webkit-tap-highlight-color: transparent;

      transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;

      &:hover {
        transform: scale(1.09);
        opacity: 1;
      }

      svg {
        color: #000;
        stroke-width: 3;
        width: 80%;
        height: 80%;
      }
    }

    @media (max-width: $screen-xxs-max) and (orientation: portrait) {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      width: 100%;
      height: auto;

      margin-left: 0;

      &__button {
        background: transparent;
        box-shadow: none;
        width: 50%;
        height: auto;
        border-radius: 0;
        position: absolute;
        height: 100%;
        left: -10px;

        &:last-child {
          left: auto;
          right: -10px;
        }

        svg {
          display: none;
        }
      }
    }
  }
}
</style>

<script>
export default {
  emits: ["clickPrev", "clickNext", "touchstart"],

  props: {
    isDisablePointerEvents: {
      type: Boolean,
      require: false,
      default: false,
    },

    isShowPrev: {
      type: Boolean,
      require: false,
      default: true,
    },

    isShowNext: {
      type: Boolean,
      require: false,
      default: true,
    },

    navigationType: {
      type: String,
      require: false,
      default: "default",
      validator: (prop) => ["default", "arrows"].includes(prop),
    },
  },

  data() {
    return {
      touchTimeLength: 0,
      minHoldTime: 250,
      touchHoldInterval: null,

      isPreventClickonSwpe: false,

      touchMoveStartCoordsSum: 0,
    };
  },

  methods: {
    preventClickOnSwipe(e) {
      if (this.isPreventClickonSwpe) {
        return;
      }

      const currentTouchPosSum = e.touches[0].clientX + e.touches[0].clientY;

      if (this.touchMoveStartCoordsSum === 0) {
        this.touchMoveStartCoordsSum = currentTouchPosSum;
      }

      const moveDifference = Math.abs(
        this.touchMoveStartCoordsSum - currentTouchPosSum
      );

      if (moveDifference > 15) {
        this.touchMoveStartCoordsSum = 0;
        this.isPreventClickonSwpe = true;
      }
    },

    touchHandler() {
      const touchTimeStamp = Date.now();

      this.touchTimeLength = Date.now() - touchTimeStamp;
      this.touchHoldInterval = setInterval(() => {
        this.touchTimeLength = Date.now() - touchTimeStamp;

        if (this.touchTimeLength > this.minHoldTime) {
          clearInterval(this.touchHoldInterval);

          this.$emit("touchstart");
        }
      }, 50);
    },

    touchendHandler(callback) {
      clearInterval(this.touchHoldInterval);
      this.touchMoveStartCoordsSum = 0;

      if (
        this.touchTimeLength > this.minHoldTime ||
        this.isPreventClickonSwpe
      ) {
        this.touchTimeLength = 0;
        this.isPreventClickonSwpe = false;

        return;
      }

      callback();
    },
  },
};
</script>
